<template>
	<picker
		class="emoji-picker mt-3"
		title="Select Emoji"
		:native="true"
		:data="emojiIndex"
		@select="select">
	</picker>
</template>

<script>
import data from 'emoji-mart-vue-fast/data/all.json';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';
import 'emoji-mart-vue-fast/css/emoji-mart.css';

const emojiIndex = new EmojiIndex(data);

export default {
	name: 'EmojiPicker',
	components: {
		Picker,
	},
	data() {
		return {
			emojiIndex,
		};
	},
	methods: {
		select(emoji) {
			this.$emit('select', emoji);
		},
	},
};
</script>
